// utils
import { setLocalStorage } from '@zola-helpers/client/dist/es/util/storage';
import { createDefaultRegistryUser } from '@zola-helpers/client/dist/es/api/onboard';
import { getDateUtc } from '@zola-helpers/client/dist/es/util/dateUtils';
import { trackOnboardingStarted } from '@zola-helpers/client/dist/es/tracking/onboard/onboardEvents';
import {
  BUSINESS_UNIT,
  COMPONENT,
} from '@zola-helpers/client/dist/es/tracking/onboard/onboardTrackingConstants';

export const REGISTRY_CHECKLIST_URL = '/registry/checklist';
export const POST_AUTH_NAV_REGISTRY_URL = '/onboard/new';

export const handleSkipRegistryOnboarding = (regCreatedCb: () => void) => {
  trackOnboardingStarted(BUSINESS_UNIT.WEDDING_REGISTRY, COMPONENT.REGISTRY);
  const started_at = getDateUtc().toISOString();
  createDefaultRegistryUser(started_at)
    .then(() => regCreatedCb())
    .catch(() => undefined);
};

export const handleYWRegLanding = () => {
  handleSkipRegistryOnboarding(() => {
    setLocalStorage('fromRegistryOnboarding', 'true');
    window.location.assign(REGISTRY_CHECKLIST_URL); // Skip onboarding, go to Checklist with walkthrough
  });
};

export const handlePostAuthRegLanding = () => {
  if (typeof window === 'undefined') return;
  window.location.assign(POST_AUTH_NAV_REGISTRY_URL); // Send to onboarding, post onboarding go to Add Gifts
};
